import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'

import ErrorDisplay from './ErrorDisplay';
import PageTitle from './PageTitle';
import CartContents from './CartContents';
import Waiting from './Waiting';

import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import useMediaQuery from '@mui/material/useMediaQuery';
import clsx from 'clsx';
import useStyles from '../styles/Styles';

import { isTrue, includesSubscription } from '../utils';

import { resetErrorMessage, fetchCart, deleteFromCart, checkout } from '../actions';

const Cart = () => {
	const classes = useStyles();
	const flexLayout = useMediaQuery('(max-width:850px)');
	
	const dispatch = useDispatch();
	const permissions = useSelector(state => state.permissions);
	const memberSettings = useSelector(state => state.settings.members.data);
	const user = useSelector(state => state.user);
	const cart = useSelector(state => state.cart.data);
	const message = useSelector(state => state.cart.message);
	const submitting = useSelector(state => state.cart.submitting);
	const navigate = useNavigate();
	
	const [submitted, setSubmitted] = useState(false);
	const [termsRequired, setTermsRequired] = useState(true);
	
	useEffect(() => {
		if(user.member_no > 0){
			dispatch(fetchCart())
		}
	}, [dispatch, user])
	
	useEffect(() => {
		setSubmitted(false)
	}, [cart])
	
	useEffect(() => {
		if(isTrue(memberSettings.show_terms_and_conditions) && includesSubscription(cart)){
			setTermsRequired(true);
		} else {
			setTermsRequired(false);
		}
	},[memberSettings, cart])
	
	const dispatchDelete = (course_code) => {
		setSubmitted(true);
		dispatch(resetErrorMessage());
		dispatch(deleteFromCart(course_code));
	}
	
	const checkoutRequest = () => {
		if(!termsRequired){
			dispatch(checkout());
		}
		navigate('/checkout')
	}
	
	return (<>
	{ submitted ?
	<ErrorDisplay 
		hide_main_button={true}
		extra_button={{
			atts: {
				onClick: () => {
					setSubmitted(false);
					dispatch(fetchCart(true));
					dispatch(resetErrorMessage());
				}
			},
			text: 'Dismiss',
		}}
	/> : 
	<ErrorDisplay />
	}
	<Paper className={clsx(classes.innerContent, classes.page)} square={true}>
	<PageTitle title='Cart' />
	{permissions.cart_available ?
	(submitted  ? 
		( message ? null : <Waiting message='Submitting request. Please wait...' /> ) :
		<>
		<CartContents 
			flexLayout={flexLayout} 
			handleRemoveItem={dispatchDelete}
		/>
		{cart.length > 0 ?
		<div className={classes.formButtons}>
		<Button color="primary" disabled={submitting || submitted}
			onClick={() => dispatchDelete(false)}
		>Clear cart</Button>
		<Button color="primary" variant="contained" onClick={() => checkoutRequest()}>Checkout</Button>
		</div>
		: null }
		</>
	) : null }
	</Paper>
	</>
)};

export default Cart